import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CashIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M20 19a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16Zm0-12h-1.69L21 9.69V8a1 1 0 0 0-1-1ZM8.31 7h7.18l4.9 4.9-5.1 5.1H8.5l-5.1-5.1L8.31 7ZM4 7h1.49L3 9.49V8a1 1 0 0 1 1-1Zm-1 9v-1.69L5.69 17H4a1 1 0 0 1-1-1Zm18-1.89L18.11 17H20a1 1 0 0 0 1-1v-1.89Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default CashIcon;
